export default "__VITE_ASSET__DpI3OFpQ__"